import React from "react";
import Parser from "../../parser";
import HTMLParser from "../../htmlParser";
const Quote = (props) => {
    const { attributes, innerBlocks } = props;
    const { className, anchor, citation } = attributes;
    return (React.createElement("blockquote", { className: className, id: anchor || "" },
        React.createElement(Parser, { structure: innerBlocks }),
        citation && (React.createElement("cite", null,
            React.createElement(HTMLParser, null, citation)))));
};
export default Quote;
